module.exports = require("@pb/kit-component-combo-box");